import { throwNever } from '@shared/utils/throwNever.js';
import { customHash } from '@shared/utils/customHash.js';

import type { GroupKey, GroupType } from '../analytics.types.js';
import { convertUserType } from './convertUserType.js';

export const parseGroupProperties = <TGroupType extends GroupType>(props: {
  groupType: TGroupType;
  groupKey: GroupKey<TGroupType>;
}) => {
  switch (props.groupType) {
    case 'userType':
      return { parsedGroupType: 'userType', parsedGroupKey: convertUserType(props.groupKey as GroupKey<'userType'>) };
    case 'healthCategory':
      return { parsedGroupType: 'healthCategory', parsedGroupKey: customHash(props.groupKey) };
    case 'checkoutType':
      return { parsedGroupType: 'checkoutType', parsedGroupKey: props.groupKey as GroupKey<'checkoutType'> };
    default: {
      return throwNever(props.groupType);
    }
  }
};
